import React from 'react';
import type { LinkTreeItem } from '../../../@types/link-tree';
import type { Property } from '../../../@types/vehicle-properties';
import PropertyComponent from './property';

interface IPropertiesProps {
  linkTree: { [key: string]: LinkTreeItem | undefined };
  properties: Property[];
  disblePropertyLinks?: boolean;
}

const PropertyItems = ({ properties, linkTree, disblePropertyLinks }: IPropertiesProps) => {
  return (
    <div data-wx-datalist="">
      <ul className="data-list">
        {properties.map((property, index) => {
          return (
            <PropertyComponent
              link={linkTree?.[property.key]}
              property={property}
              key={`${property.name}-${index}`}
              disblePropertyLinks={disblePropertyLinks}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default PropertyItems;
